import go from 'gojs';
import { getScrollY } from '../../almightyElementWrapper';
import { apiGet, getHostApi } from '../../apiWrapper';
import { updateObject } from "../../storeFunctions";
import { diagram } from '../diagram/initial';
import { _getNodeHeaderColor } from '../diagram/templates/node';
import { tooltipInitial } from './initial';
import { _name } from '../common/constants';

// KEYS
const actions = {
    LINK_TOOLTIP: { _name: _name + '_LINK_TOOLTIP' },
    NODE_TOOLTIP: { _name: _name + '_NODE_TOOLTIP' },
    CONTEXT_MENU: { _name: _name + '_CONTEXT_MENU' },
    COMMON_TOOLTIP: { _name: _name + '_COMMON_TOOLTIP' },
};
actions.LINK_TOOLTIP = Object.assign(actions.LINK_TOOLTIP, {
    SHOW: actions.LINK_TOOLTIP._name + '_SHOW',
    HIDE: actions.LINK_TOOLTIP._name + '_HIDE'
});
actions.COMMON_TOOLTIP = Object.assign(actions.COMMON_TOOLTIP, {
    SHOW: actions.COMMON_TOOLTIP._name + '_SHOW',
    HIDE: actions.COMMON_TOOLTIP._name + '_HIDE'
});
actions.NODE_TOOLTIP = Object.assign(actions.NODE_TOOLTIP, {
    SHOW: actions.NODE_TOOLTIP._name + '_SHOW',
    HIDE: actions.NODE_TOOLTIP._name + '_HIDE'
});
actions.CONTEXT_MENU = Object.assign(actions.CONTEXT_MENU, {
    SHOW: actions.CONTEXT_MENU._name + '_SHOW',
    HIDE: actions.CONTEXT_MENU._name + '_HIDE',
    LOAD: actions.CONTEXT_MENU._name + '_LOAD'
});

// MAP
const actionMap = {
    //inhouse actions
    [`${actions.LINK_TOOLTIP.SHOW}`]: (state, data) => updateObject(state, { linkTooltip: updateObject(state.linkTooltip, { show: true, context: data }) }),
    [`${actions.LINK_TOOLTIP.HIDE}`]: (state, data) => updateObject(state, { linkTooltip: updateObject(state.linkTooltip, { ...tooltipInitial }) }),
    [`${actions.NODE_TOOLTIP.SHOW}`]: (state, data) => updateObject(state, { nodeTooltip: updateObject(state.nodeTooltip, { show: true, context: data }) }),
    [`${actions.NODE_TOOLTIP.HIDE}`]: (state, data) => updateObject(state, { nodeTooltip: updateObject(state.nodeTooltip, { ...tooltipInitial }) }),
    [`${actions.COMMON_TOOLTIP.SHOW}`]: (state, data) => updateObject(state, { commonTooltip: updateObject(state.commonTooltip, { show: true, context: data }) }),
    [`${actions.COMMON_TOOLTIP.HIDE}`]: (state, data) => updateObject(state, { commonTooltip: updateObject(state.commonTooltip, { ...tooltipInitial }) }),
    [`${actions.CONTEXT_MENU.LOAD}`]: (state, data) => updateObject(state, { contextMenu: updateObject(state.contextMenu, { loading: true, show: false }) }),
    [`${actions.CONTEXT_MENU.SHOW}`]: (state, data) => updateObject(state, { contextMenu: updateObject(state.contextMenu, { show: true, context: data, loading: false }) }),
    [`${actions.CONTEXT_MENU.HIDE}`]: (state, data) => updateObject(state, { contextMenu: updateObject(state.contextMenu, { ...tooltipInitial }) }),
}

// FUNCTIONS
function _fixToolTipPosition(position, id) {
    var popup = document.getElementById(id);
    var dgrm = document.getElementById('diagramPlane');

    if ((position.pageX + 40 + popup.offsetWidth) >= dgrm.offsetWidth) {
        popup.style.left = '0px';
        popup.style.left = position.pageX - popup.offsetWidth + 'px';
        if (popup.offsetLeft < dgrm.offsetLeft)
            popup.style.left = dgrm.offsetLeft + 'px';
    }

    if ((position.pageY + popup.offsetHeight + 20) >= (dgrm.offsetTop + dgrm.offsetHeight)) {
        popup.style.top = position.pageY - popup.offsetHeight + 'px'
    }
}

function _showLinkTooltip(data, dgrm, position, dispatch) {
    const linkData = {
        parent: dgrm.findNodeForKey(data.ParentID),
        child: dgrm.findNodeForKey(data.ChildID)
    }

    dispatch({ type: actions.LINK_TOOLTIP.SHOW, data: { data, linkData, position: { x: position.pageX + 10, y: position.pageY + 10 } } });

    _fixToolTipPosition(position, 'entityLinkPopup');
}

function _showNodeTooltip(data, position, dispatch) {
    dispatch({ type: actions.NODE_TOOLTIP.SHOW, data: { data, position: { x: position.pageX + 10, y: position.pageY + 10 } } });

    _fixToolTipPosition(position, 'entityHoverPopup');
}

function _showCommonTooltip(text, position, dispatch) {
    if (diagram._noConflictGoBtnTooltip !== undefined && diagram._noConflictGoBtnTooltip !== null) {
        window.clearTimeout(diagram._noConflictGoBtnTooltip);
    }

    diagram._noConflictGoBtnTooltip = window.setTimeout(function () {
        dispatch({ type: actions.COMMON_TOOLTIP.SHOW, data: { text, position: { x: position.pageX + 10, y: position.pageY + 10 } } });
        _fixToolTipPosition(position, 'commonHoverPopup');
    }, 250);
}

function _hideCommonTooltip(dispatch) {
    if (diagram._noConflictGoBtnTooltip !== undefined && diagram._noConflictGoBtnTooltip !== null) {
        window.clearTimeout(diagram._noConflictGoBtnTooltip);
        diagram._noConflictGoBtnTooltip = undefined;
    }

    dispatch({ type: actions.COMMON_TOOLTIP.HIDE });
}

function _showContextMenu(obj, node, dispatch) {
    dispatch({ type: actions.CONTEXT_MENU.LOAD });
    const ele = document.querySelector('#entityContextMenu');
    ele.onmouseleave = function () { dispatch({ type: actions.CONTEXT_MENU.HIDE }); ele.onmouseleave = undefined; };
    node.diagram.toolManager.contextMenuTool.currentContextMenu = go.GraphObject.make(go.HTMLInfo, { mainElement: ele });
    apiGet(`${getHostApi()}/api/search/${node.data.EntityID}`, null, data => {
        const docloc = node.diagram.transformDocToView(node.part.position);
        const parent = document.querySelector('#diagramPlane').getBoundingClientRect();
        const coloring = _getNodeHeaderColor(node.data);
        var maxWidth = 248 * diagram.nodeDiagram.scale;
        if (maxWidth < 110)
            maxWidth = 110;
        dispatch({
            type: actions.CONTEXT_MENU.SHOW, data: {
                reports: data.data.reports,
                entityId: node.data.EntityID,
                entityName: node.data.Name,
                entityType: node.data.EntityType,
                ico: node.data.IC,
                dateOfBirth: node.data.DateOfBirthOrCreationDate,
                dateOfBirthFormated: node.data.DateOfBirthOrCreationDateFormated,
                address: node.data.FullAddress,
                hasWarnings: node.data.WarningShortcuts.length > 0,
                coloring: coloring,
                position: { x: docloc.x + parent.left + node.part.actualBounds.width * diagram.nodeDiagram.scale, y: docloc.y + parent.top + getScrollY() - 5 },
                maxWidth: maxWidth
            }
        });
    });
}

export {
    _hideCommonTooltip, _showCommonTooltip, _showContextMenu, _showLinkTooltip, _showNodeTooltip,
    actionMap as tooltipsActionMap, actions as tooltipsActions
};
